import {i18n} from "@/i18n/i18n";
export const years = ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021'];
export const months = [
    {id: '', name: ''},
    {id: 1, name: i18n.t('januar')},
    {id: 2, name: i18n.t('februar')},
    {id: 3, name: i18n.t('mart')},
    {id: 4, name: i18n.t('april')},
    {id: 5, name: i18n.t('maj')},
    {id: 6, name: i18n.t('jun')},
    {id: 7, name: i18n.t('jul')},
    {id: 8, name: i18n.t('avgust')},
    {id: 9, name: i18n.t('septembar')},
    {id: 10, name: i18n.t('oktobar')},
    {id: 11, name: i18n.t('novembar')},
    {id: 12, name: i18n.t('decembar')}
];